import React, { createContext, useContext, ReactNode } from 'react';
import { emailTemplates } from '../templates/emailTemplates';

interface EmailContextType {
  selectedTemplateId: string;
  setSelectedTemplateId: (templateId: string) => void;
  getSelectedTemplate: () => typeof emailTemplates[0];
}

const EmailContext = createContext<EmailContextType | undefined>(undefined);

export const EmailProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedTemplateId, setSelectedTemplateId] = React.useState(emailTemplates[0].id);

  const getSelectedTemplate = () => {
    return emailTemplates.find(template => template.id === selectedTemplateId) || emailTemplates[0];
  };

  return (
    <EmailContext.Provider value={{ 
      selectedTemplateId, 
      setSelectedTemplateId,
      getSelectedTemplate
    }}>
      {children}
    </EmailContext.Provider>
  );
};

export const useEmail = () => {
  const context = useContext(EmailContext);
  if (context === undefined) {
    throw new Error('useEmail must be used within an EmailProvider');
  }
  return context;
}; 